import gql from 'graphql-tag';

import type { Language, LanguageTargetFormality } from 'src/data/generation';
import type { GenerationTool } from 'src/data/generationTool';
import type { ShortFormSection } from 'src/data/shortForm';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ImproveShortFormSections(
    $projectId: ID!
    $generationTool: GenerationToolEnum!
    $sections: [SectionInput!]!
    $keywords: [String!]
    $variationCount: Int!
    $language: String!
    $languageTargetFormality: LanguageTargetFormalityEnum
  ) {
    improveShortFormSections(
      projectId: $projectId
      generationTool: $generationTool
      sections: $sections
      keywords: $keywords
      variationCount: $variationCount
      language: $language
      languageTargetFormality: $languageTargetFormality
    ) {
      id
    }
  }
`;

export const improveShortFormSections = async ({
  projectId,
  generationTool,
  sections,
  keywords,
  variationCount,
  language,
  languageTargetFormality,
}: {
  projectId: ID;
  generationTool: GenerationTool;
  sections: unknown[];
  keywords: string[];
  variationCount: number;
  language: Language;
  languageTargetFormality: LanguageTargetFormality;
}) => {
  const variables = {
    projectId,
    generationTool,
    sections,
    keywords,
    variationCount,
    language,
    languageTargetFormality,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<ShortFormSection>(result.data);
};
